exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DrawerVcDemo h4[data-v-77ddffaa]{color:#066}.DrawerVcDemo .demoItem[data-v-77ddffaa]{padding:5px 0;font-size:18px;border-bottom:1px dotted #999}.DrawerVcDemo .item[data-v-77ddffaa]{margin-right:15px;margin-bottom:10px}.DrawerVcDemo .content-left[data-v-77ddffaa]{width:360px;max-width:80%;-webkit-box-sizing:border-box;box-sizing:border-box}.DrawerVcDemo .content-top[data-v-77ddffaa]{height:120px;max-height:80%;-webkit-box-sizing:border-box;box-sizing:border-box}", ""]);

// exports
